<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
       <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('stock.title', {bons: type})}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a
              class="button is-addOrEdit"
              @click="checkPermissions(stockPerm.maj)
                ? $router.push({ name:  route })
                : showPopUp()"
              :class="{'button-access-no-permission': !checkPermissions(stockPerm.maj)}">
              {{ $t('stock.actions.add', {bon: bon})}}
            </a>
          </div>
        </div>
       </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-narrow">
            <b-input :placeholder="$t('general.button.search')" type="search" icon="magnify"
              v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('stock.actions.filtre') }}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
          <div class="column is-narrow">
            <exportExcelButton
              :perm="stockPerm.exporter"
              :query="exportExcelQuery"/>
          </div>
          <parametrage-table
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
    </div>
    <v-server-table v-if="startArrayRendering"
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable">
      <template #afterTable>
        <table-items-in-view
        :perPage="resultPerPage"
        @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template #selected="{ row }">
        <div class="has-text-centered">
          <b-checkbox v-model="row.selected">
          </b-checkbox>
        </div>
      </template>
      <template #dateBon="{ row }">
        <b-field>
          <router-link :to="{ name: detailRouteName,
            params: {id: row.id}}"
            class="lien"
            :class="{'text-access-no-permission':
            !checkPermissions(stockPerm.lecture)}">
              {{ new Date(row.dateBon).toLocaleDateString() }}
          </router-link>
        </b-field>
      </template>
      <template #lieuDeStockage="{ row }">
        <b-field>
          <router-link target="_blank" :to="{ name: 'c.bodac.clients/contacts-client',
            params: {id: row.lieuDeStockageId}}"
              class="lien"
              :class="{'text-access-no-permission':
            !checkPermissions(stockPerm.lecture)}">
            {{ row.lieuDeStockage.nomCommercial }}
          </router-link>
        </b-field>
      </template>
      <template #origine="{ row }">
        <div v-if="row.origine === constantes.ORIGINE_TYPE_DIVERS">
          {{ getTraductionOrigin(row.origine) }}
        </div>
        <router-link v-else :to="{ name: getLienOrigine,
                     params: {id: row.reference.id}}"
                        class="lien" target="_blank"
                         :class="{'text-access-no-permission':
                     !checkPermissions(stockPerm.lecture)}">
              {{ getTraductionOrigin(row.origine) }}
            </router-link>
      </template>
      <template #edit="{ row }">
        <router-link
            :to="{ name: editionRouteName, params: { id: row.id } }"
          class="is-cursor-pointer">
          <b-icon
            :class="{'text-access-no-permission': !checkPermissions(stockPerm.maj)}"
            icon="pencil-box-outline"
            type="is-success">
          </b-icon>
        </router-link>
      </template>
      <template #archiver="{ row }">
        <archive-list-button
          :query="() => archiverStock(row)"
          :permissions="stockPerm.supprimer"
          :title="row.actif
            ? $t('stock.popUpArchivage.titleArchiver', {bon : bon})
            : $t('stock.popUpArchivage.titleDesarchiver', {bon : bon})"
          :successMessage="row.actif
            ? $t('stock.messages.success.archiver', {Bon: bon})
            : $t('stock.messages.success.desarchiver',{Bon: bon})"
          @done="recherche()"
          :actif="row.actif"/>
      </template>
      <template #delete="{ row }">
        <delete-list-button
          :query="() => deleteStock(row)"
          :tooltipLabel="cantBeDeleted(row) ?
            $t('stock.actions.deleteCommande') : null"
          :validation="() => {}"
          :permissions="stockPerm.supprimer"
          :title="$t('stock.delete.titleStock', {bon: bon})"
          :subtitle="$t('general.suppression.sousTitre')"
          :successMessage="$t('stock.delete.suppressionStock',
            {Bon: bonMaj})"
          :disabled="cantBeDeleted(row)"
          :tooltipPosition="cantBeDeleted(row) ?
            'is-left' : 'is-top'"
          @done="recherche()"/>
      </template>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-bon-stock ref="filtreListeStock"
          @toggleFiltre="changeValueShowFiltreAndLockMenu"
          :isEntree="isEntree"
          :sens="isEntree ? constantes.SENS_VENTE : constantes.SENS_ACHAT"
          v-model="critereRecherche"
          @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  BONS_ENTREE,
  BONS_SORTIE,
  EDITION_BON_ENTREE_ROUTE,
  EDITION_BON_SORTIE_ROUTE,
  BON_ENTREE,
  BON_SORTIE,
  DATE_DE_BON_ENTREE,
  DATE_DE_BON_SORTIE,
  DETAILS_BON_ENTREE_ROUTE,
  DETAILS_BON_SORTIE_ROUTE,
  BON_STOCK_TYPE_ENTREE,
  BON_STOCK_TYPE_SORTIE,
  ORIGINE_TYPE_DIVERS,
  ORIGINE_BON_DIVERS,
  ORIGINE_COMMANDE,
  BON_ENTREE_MAJ,
  BON_SORTIE_MAJ,
  EXPORT_EXCEL_BONSTOCK,
} from '@/configuration/bonStock/menuStockConf';
import { archiver, remove } from '@/api/gabed/bonStock';
import {
  TEXTS, RESULTS_PER_PAGE,
  NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import breadcrumb from '@/components/general/breadcrumb';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { BON_STOCK } from '@/configuration/bonStock/permissionsStockConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import genererCritereRechercheStock from '@/services/gabed/bonStock/generer/genererCritereRechercheStock';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import archiveListButton from '@/components/general/button/archiveListButton';
import messageErreur from '@/services/general/messageErreur';
import transformerBonStock from '@/services/bonStock/filters/bonStockServerTableDataTransformer';

import parametrageTable from '@/components/general/parametrageTable';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { SENS_ACHAT, SENS_VENTE } from '@/configuration/devisConf';
import filtreBonStock from '@/components/bonStock/filtreListeBonStock';
import deleteListButton from '@/components/general/button/deleteListButton';

const Permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');

export default {
  props: {
    isEntree: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      stockPerm: BON_STOCK,
      displayInactif: true,
      stocksSelectionne: false,
      showFiltre: false,
      constantes: {
        SENS_ACHAT,
        SENS_VENTE,
        ORIGINE_TYPE_DIVERS,
      },
      listeFilter: [],
      popup: false,
      title: null,
      subtitle: null,
      option: null,
      startArrayRendering: false,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    TableItemsInView,
    archiveListButton,
    filtreBonStock,
    parametrageTable,
    exportExcelButton,
    deleteListButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    referenceTable() {
      return this.isEntree ? 'tableBonStockEntree' : 'tableBonStockSortie';
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('stock.breadcrumb.liste', { bons: this.type }), route: { name: '' }, isActive: true },
      ];
    },
    storeName() {
      return this.isEntree ? 'bonStockEntree' : 'bonStockSortie';
    },
    critereRecherche: {
      get() {
        return this.$store.getters[`${this.storeName}/critereRecherche`];
      },
      set(value) {
        this.$store.commit(`${this.storeName}/SET_CRITERE_RECHERCHE`, value);
      },
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    total() {
      return this.$store.getters[`${this.storeName}/total`];
    },
    items() {
      return this.$store.getters[`${this.storeName}/items`];
    },
    type() {
      return this.isEntree ? this.$t(BONS_ENTREE) : this.$t(BONS_SORTIE);
    },
    route() {
      return this.isEntree ? EDITION_BON_ENTREE_ROUTE : EDITION_BON_SORTIE_ROUTE;
    },
    bon() {
      return this.isEntree ? this.$t(BON_ENTREE) : this.$t(BON_SORTIE);
    },
    bonMaj() {
      return this.isEntree ? this.$t(BON_ENTREE_MAJ) : this.$t(BON_SORTIE_MAJ);
    },
    dateDeBon() {
      return this.isEntree ? DATE_DE_BON_ENTREE : DATE_DE_BON_SORTIE;
    },
    getLienOrigine() {
      return this.isEntree ? 'c.bodac.commandes' : 'c.logistique.ordre_travail-tech';
    },
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    nombreCritere() {
      const banCritereKey = ['auto', 'type', 'societeId', 'dateDeBon'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      if (this.critereRecherche.dateDeBon.dateDebut || this.critereRecherche.dateDeBon.dateFin) {
        nbCritere += 1;
      }
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_BONSTOCK,
        typeExport: '',
        filtres: transformerBonStock(this.lastPayload),
      };
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateBon: this.$t(this.dateDeBon),
          lieuDeStockage: this.$t('stock.tab.lieuDeStockage'),
          origine: this.$t('stock.tab.origine'),
          commentaire: this.$t('stock.tab.commentaire'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: ['dateBon', 'origine'],
        requestFunction: data => {
          if (!data || !data.query) {
            data.query = cloneDeep(this.critereRecherche);
          }
          data.query.societeId = this.societeActiveId;
          data.query.type = this.isEntree ? BON_STOCK_TYPE_ENTREE : BON_STOCK_TYPE_SORTIE;
          return this.actionsLoadBonStock(data);
        },
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.total,
          };
        }),
      };
    },
    columns() {
      return ['selected', 'dateBon', 'lieuDeStockage', 'origine', 'commentaire', 'edit', 'archiver', 'delete'];
    },
    getAllLignesSelected() {
      return this.items.filter((stock) => { return stock.selected; });
    },
    allLigneStocksSelected() {
      return this.getAllLignesSelected.length === this.items.length;
    },
    iconSelectTotal() {
      if (this.allLigneStocksSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    editionRouteName() {
      return this.isEntree ? EDITION_BON_ENTREE_ROUTE : EDITION_BON_SORTIE_ROUTE;
    },
    detailRouteName() {
      return this.isEntree ? DETAILS_BON_ENTREE_ROUTE : DETAILS_BON_SORTIE_ROUTE;
    },
  },
  methods: {
    async actionsLoadBonStock(data) {
      const res = await this.$store.dispatch(`${this.storeName}/loadBonStock`, data);
      return res;
    },
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      this.setLockMenu(!this.lockMenu);
    },
    selectAll() {
      const select = this.items.every(el => !el.selected);
      this.items.forEach((el) => { el.selected = select; });
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    async archiverStock(row) {
      if (!row) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(row.id, row.actif);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async deleteStock(row) {
      if (!row) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(row.id);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable]?.refresh();
    },
    getTraductionOrigin(origin) {
      return origin === ORIGINE_TYPE_DIVERS ? this.$t(ORIGINE_BON_DIVERS)
        : this.$t(ORIGINE_COMMANDE);
    },
    reinitialiser() {
      this.$refs.filtreListeStock.viderCritere();
    },
    cantBeDeleted(row) {
      return this.isEntree && row.origine === 'Commande';
    },
  },
  mounted() {
    if (!this.critereRecherche) this.setCritereRecherche(cloneDeep(genererCritereRechercheStock()));
  },
};
</script>
